import { ActivityTypeData } from '@apeiron/common'
import { useCallback } from 'react'

const useMakeActivity = (): Hook => {
  // public
  const makeActivityTypeData = useCallback((input: any): ActivityTypeData => {
    return input
  }, [])

  return {
    makeActivityTypeData
  }
}

type Hook = {
  makeActivityTypeData: (input: any) => ActivityTypeData
}

export default useMakeActivity
